import { mapGetters, mapActions } from "vuex";
import { scrollTop } from '@/plugins/utils/scrollTop'
import NP from 'number-precision'
export default {
  data () {
    return {
      totalItems: [],
      sitedata: [],
      rateData: [],
      mytlpa: 100
    }
  },
  computed: {
    ...mapGetters(['getAllGame', 'getExgameList']),
    query () {
      return this.$route.query
    },
    getalllist () {
      let exgameLits = this.getExgameList.map(it => {
        return {
          gameid: it.id,
          gamename: it.gamename
        }
      })
      if (this.getAllGame.length == 0) return
      let arr = [...exgameLits, ...this.getAllGame]
      return arr
    },
    stidlistLengthStatus () {
      let status = false
      if (this.query.stidlist && String(this.query.stidlist).split(",").length > 1) status = true
      return status
    }
  },
  methods: {
    async getmytlpa () {
      const mytlpaData = await this.$axios.liveshow.linkmytlpa(this.query.stidlist)
      this.mytlpa = mytlpaData[0].mytlpa
    },
    itemsSort () {
      const fn = (obj) => {
        const keys = Object.keys(obj)
        for (let k of keys) {
          if (k.includes('name') && !k.includes('username')) {
            return obj[k]
          }
        }
        return ''
      }
      this.totalItems.sort((a, b) => fn(a).localeCompare(fn(b)))
      this.totalItems.sort((a, b) => {
        if (a.hie != b.hie) return a.hie - b.hie
      })

      Object.keys(this.totalData).forEach(key =>{
        this.totalData[key].sort((a, b) => fn(a).localeCompare(fn(b)))
        this.totalData[key].sort((a, b) => {
          if (a.hie != b.hie) return a.hie - b.hie
        })
      })

      this.sitedata.forEach(item => {
        item.data.sort((a, b) => fn(a).localeCompare(fn(b)))
        item.data.sort((a, b) => {
          if (a.hie != b.hie) return a.hie - b.hie
        })
      })
    },
    itemsDefault () {
      const length = this.$route.query.gmclist.split(',')
      let result = length.reduce((acc, val) => (acc[val] = [], acc), {})
      this.loading = false
      return result
    },
    getGamename (id) {
      const find = this.getalllist.find(it => it.gameid == id)
      let result = find ? find.gamename : null
      return result
    },
    sunl1total (data, uppsKey) {
      let l1totalAll = 0
      let resutl = Object.keys(data).reduce((acc, val) => {
        const l1total = this.l1totalReduce(data[val], uppsKey)
        l1totalAll += l1total
        acc[val] = data[val].map(it => (it.l1total = l1total, it))
        return acc
      }, {})
      return { l1totalAll, data: resutl }
    },
    l1totalReduce (data, uppsKey) {
      return data.reduce((acc, val) => acc += val[uppsKey], 0)
    },
    sunTotal ({ l1total, name, name2 }, obj) {
      let result = {}
      const array = Object.values(this.totalData).reduce((acc, val) => (acc.push(...val), acc), [])
      for (let i = 0; i < array.length; i++) {
        const it = array[i];
        const key = Object.keys(it)
        const _name = it[name] + it[name2]
        if (_name in result == false) result[_name] = {}
        for (let x = 0; x < key.length; x++) {
          const xkey = key[x];
          if (xkey in result[_name] && this.some(this.notSunArray, xkey)) {
            result[_name][xkey] += it[xkey]
          } else {
            result[_name][xkey] = it[xkey]
          }
        }
        result[_name].l1total = l1total
      }
      if (!this.stidlistLengthStatus) this.totalItems = Object.values(result).sort((a, b) => a.date > b.date ? 1 : -1)
      if (this.stidlistLengthStatus) {
        let mytlpa = obj.mytlpa == undefined ? 100 : obj.mytlpa
        this.sitedata.push({ data: Object.values(result), stid: obj.stid, stname: obj.stname, mytlpa })

        if (Object.values(result).length == 0) return

        let rateKey = ['l1pays', 'l1paysumt', 'mid', 'bupayds', 'l1pds', 'l1paysum']

        let sundata = Object.values(result).reduce((sunobj, item) => {
          for (let [key, val] of Object.entries(item)) {
            let newVal = rateKey.includes(key)
              ? NP.times(parseFloat(val).toFixed(4), (mytlpa / 100))
              : val
            if (sunobj[key] == undefined) sunobj[key] = newVal
            else sunobj[key] += newVal
          }
          return sunobj
        }, {})

        this.rateData.push({...sundata, stid: obj.stid, stname: obj.stname, mytlpa})
      }
    },
    some (ArrayData, it) {
      return ArrayData.indexOf(it) == -1
    },
    checkUrl (message) {
      if (message == "Error: API URL undefined") {
        this.$Message.error("请勿改动网站资讯!");
        this.$router.push({ name: this.$route.matched[1].name })
      }
    },
    TableScrollTop () {
      const scrollGameid = this.$route.params.scrollGameid
      if (!scrollGameid) return
      this.$nextTick(() => {
        const postions = this.$refs[`table${scrollGameid}`][0].$el.offsetTop - 10
        scrollTop(window, 0, postions, 100)
      })
    },
    getSitedata (arr) {
      arr.forEach((it, index) => {
        this.totalData = { ...this.itemsDefault(), ...it.data }
        const obj = this.sunl1total(it.data, 'l2upps')
        this.sunTotal({ l1total: obj.l1totalAll, name: 'l2name', name2: 'l2username' }, { stid: it.stid, stname: it.stname, mytlpa: it.mytlpa })
      })
    }
  },
}